// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qWlu","importantInfo":"styles_importantInfo__3M8vq"};